<template>
  <Modal v-model="modal" :title="$t('title.w20')" :mask-closable="false">
    <div>
      <ButtonSwitch :type.sync="resetType"></ButtonSwitch>
      <div v-show="resetType == 'phone'" class="content">
        <Form
          label-position="top"
          :model="phoneReLoginPswForm"
          ref="phoneReLoginPswForm"
          :rules="phoneReLoginPswFormRule"
        >
          <FormItem :label="$t('label.w41')" prop="password">
            <Input
              type="password"
              :placeholder="$t('pl.p3')"
              v-model="phoneReLoginPswForm.password"
            ></Input>
          </FormItem>
          <FormItem :label="$t('label.w34')" prop="copypassword">
            <Input
              type="password"
              :placeholder="$t('pl.p29')"
              v-model="phoneReLoginPswForm.copypassword"
            ></Input>
          </FormItem>
          <FormItem :label="$t('label.w35')" prop="code">
            <Row type="flex" :gutter="10">
              <Col span="18">
                <Input :placeholder="$t('pl.p30')" v-model="phoneReLoginPswForm.code" />
              </Col>
              <Col span="6">
                <Codebtn type="SendResetPwdCode" :to="phoneReLoginPswForm" :disabled="pwdErr" />
              </Col>
            </Row>
          </FormItem>
        </Form>
      </div>
      <div v-show="resetType == 'email'" class="content">
        <Form
          label-position="top"
          :model="emailReLoginPswForm"
          ref="emailReLoginPswForm"
          :rules="emailReLoginPswFormRule"
        >
          <FormItem :label="$t('label.w41')" prop="password">
            <Input
              type="password"
              :placeholder="$t('pl.p3')"
              v-model="emailReLoginPswForm.password"
            ></Input>
          </FormItem>
          <FormItem :label="$t('label.w34')" prop="copypassword">
            <Input
              type="password"
              :placeholder="$t('pl.p29')"
              v-model="emailReLoginPswForm.copypassword"
            ></Input>
          </FormItem>
          <FormItem :label="$t('label.w36')" prop="code">
            <Row type="flex" :gutter="10">
              <Col span="18">
                <Input :placeholder="$t('pl.p31')" v-model="emailReLoginPswForm.code" />
              </Col>
              <Col span="6">
                <Codebtn type="SendResetPwdCode" :to="emailReLoginPswForm" :disabled="pwdErr" />
              </Col>
            </Row>
          </FormItem>
        </Form>
      </div>
    </div>
    <template slot="footer">
      <Button
        type="primary"
        class="clicknext"
        :disabled="pwdErr||(
          resetType=='phone'?
          phoneReLoginPswForm.code=='':
          emailReLoginPswForm.code==''
        )"
        @click="submitValid"
      >{{$t('btn.b47')}}</Button>
    </template>
  </Modal>
</template>

<script>
import ButtonSwitch from "@/components/buttonSwitch";
import formRule from "@/libs/formRule";
import Rsa from "@/libs/Rsa";
import Codebtn from "@/components/sendCodeButton";
import { post } from "@/libs/axios";
export default {
  components: { ButtonSwitch, Codebtn },
  data() {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.resetType == "phone") {
        if (this.phoneReLoginPswForm.password != value) {
          callback(new Error(this.$t("msg.m31")));
        } else {
          callback();
        }
      } else {
        if (this.emailReLoginPswForm.password != value) {
          callback(new Error(this.$t("msg.m31")));
        } else {
          callback();
        }
      }
    };
    return {
      resetType: "phone",
      modal: false,
      phoneReLoginPswForm: {
        password: "",
        copypassword: "",
        code: "",
        verificationType: "2"
      },
      emailReLoginPswForm: {
        password: "",
        copypassword: "",
        code: "",
        verificationType: "1"
      },
      phoneReLoginPswFormRule: {
        password: formRule.logPwd,
        copypassword: [
          { required: true, message: this.$t("msg.m32"), trigger: "blur" },
          { required: true, validator: pwdCheckValidate, trigger: "blur" }
        ],
        code: formRule.code
      },
      emailReLoginPswFormRule: {
        password: formRule.logPwd,
        copypassword: [
          { required: true, message: this.$t("msg.m32"), trigger: "blur" },
          { required: true, validator: pwdCheckValidate, trigger: "blur" }
        ],
        code: formRule.code
      }
    };
  },
  computed: {
    pwdErr() {
      if (this.resetType == "phone") {
        return (
          this.phoneReLoginPswForm.password == "" ||
          this.phoneReLoginPswForm.password !=
            this.phoneReLoginPswForm.copypassword
        );
      }
      if (this.resetType == "email") {
        return (
          this.emailReLoginPswForm.password == "" ||
          this.emailReLoginPswForm.password !=
            this.emailReLoginPswForm.copypassword
        );
      }
    }
  },
  watch: {
    resetType() {
      this.$refs.phoneReLoginPswForm.resetFields();
      this.$refs.emailReLoginPswForm.resetFields();
    },
    modal(v) {
      if (v) {
        this.$refs.phoneReLoginPswForm.resetFields();
        this.$refs.emailReLoginPswForm.resetFields();
      }
    }
  },
  methods: {
    async submitValid() {
      let resetType = this.resetType;
      // 提交前验证表单
      let valid = await this.$refs[
        resetType == "phone" ? "phoneReLoginPswForm" : "emailReLoginPswForm"
      ].validate();
      if (!valid) return;
      this.submit();
    },
    async submit() {
      let pm;
      if (this.resetType == "phone") {
        pm = post("/Member/RZJProfile/SaveResetPwd", {
          passWord: Rsa(this.phoneReLoginPswForm.password),
          affirmPassWord: Rsa(this.phoneReLoginPswForm.copypassword),
          verificationType: this.phoneReLoginPswForm.verificationType,
          code: this.phoneReLoginPswForm.code
        });
      } else if (this.resetType == "email") {
        pm = post("/Member/RZJProfile/SaveResetPwd", {
          passWord: Rsa(this.emailReLoginPswForm.password),
          affirmPassWord: Rsa(this.emailReLoginPswForm.copypassword),
          verificationType: this.emailReLoginPswForm.verificationType,
          code: this.emailReLoginPswForm.code
        });
      }
      pm.then(res => {
        if (res.err) {
          res.throw();
        }
        if (res.err == 0) {
          this.$axios.get("/Member/RZJAuth/Logout").then(res => {
            if (res.err) return res.throw();
            this.$Message.success(this.$t("msg.m37"));
            this.$router.push({ name: "login" });
            this.$store.commit("user/logstate", false);
            this.$store.dispatch("user/getUser");
          });
        }
      });
    }
  }
};
</script>
